import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 51 126"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2BC4F0",
      d: "M40.47 7.405a5.333 5.333 0 1 1 10.083-3.477A5.333 5.333 0 0 1 40.47 7.405Zm2.02 113.893a1 1 0 0 1-.632 1.265l-8.538 2.846a1 1 0 0 1-.633-1.897l7.59-2.53-2.53-7.59a.999.999 0 1 1 1.898-.632l2.846 8.538ZM45.916 6.581C25.85 15.44 5.152 31.691 2.973 59.297L.98 59.14C3.244 30.446 24.773 13.728 45.107 4.752l.808 1.83ZM2.973 59.297C.795 86.903 20.401 109.925 41.99 120.72l-.894 1.789C19.063 111.492-1.285 87.835.98 59.14l1.993.157Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "arrow-down"}) } }